import { useNavigate } from "react-router";
import { NotFoundHeader, NotFoundText, ReturnToMyOrdersButtonText } from "constants/text.ts";
import { NotFoundPageWrapper } from "./NotFoundPage.styles.ts";
import { APIErrorFaceBox } from "components/Common/APIErrorFaceBox/APIErrorFaceBox.tsx";

const NotFound = () => {
	const navigateTo = useNavigate();

	return (
		<NotFoundPageWrapper data-testid="not-found-container">
			<div>
				<div>
					<img
						src="/assets/tandem_logos/tandem.png"
						alt="Tandem Logo"
						data-testid="not-found-tandem-logo"
					/>
				</div>
				<APIErrorFaceBox
					buttonText={ReturnToMyOrdersButtonText}
					buttonClick={() => navigateTo("/orders")}
					headerText={NotFoundHeader}
					descriptionText={NotFoundText}
					faceBoxType="notFound"
				/>
			</div>
		</NotFoundPageWrapper>
	);
};

export default NotFound;
